module.exports = __webpack_public_path__ + "static/media/account.6f1b19b4.svg";